module.exports = __webpack_public_path__ + "06_long_gray.89412920.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_long_gray.png
// module id = IoNT
// module chunks = 0